import React, { useMemo } from 'react';
import { Select } from 'antd';
import useSalesOffices from '../../hooks/useSalesOffices';

const SalesOfficeSelect = ({ placeholder = "Buscar oficina de ventas:", onlyOwnedByCurrentUser = false, ...restProps }) => {
    const { data, isLoading }  = useSalesOffices();
    
    const filterOptionHandler = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const options = useMemo(() => data 
        ? data
            .filter(d => !onlyOwnedByCurrentUser || (onlyOwnedByCurrentUser && d.isOwnedByCurrentUser))
            .map(d => ({ value: d.id, label: d.name }))
        : []
    , [data]);

    return <Select
        {...{ ...restProps, placeholder, options }}
        loading={isLoading}
        showSearch
        filterOption={filterOptionHandler} />
}

export default SalesOfficeSelect;